import { Badge } from "@shopify/polaris";
import React from "react";

export const BillingActiveBadge: React.FC = () => {
  return <Badge status="success">Active</Badge>;
};
